import styled from "styled-components";
import { borderRadius } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const ModalBody = styled.div`
  padding: ${spacing[5]};
  display: flex;
  flex-direction: column;
  gap: ${spacing[4]};
`;

export const ModalTitle = styled.h2`
  margin: 0;
  ${typographyMixin("body", 2)}
  color: ${rawColors.text.highEmphasis};
`;

export const ModalDescription = styled.p`
  margin: 0;
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.mediumEmphasis};
  line-height: 1.55;
`;

export const WarningBox = styled.div`
  background-color: ${rawColors.accent.peachLight};
  border-radius: ${borderRadius.md};
  padding: ${spacing[3]};
  display: flex;
  align-items: flex-start;
  gap: ${spacing[3]};
`;

export const WarningContent = styled.div`
  ${typographyMixin("body", 4)}
  color: ${rawColors.text.highEmphasis};

  ul {
    margin: 0;
    padding-left: ${spacing[4]};
  }
`;

export const ImpactPanel = styled.div`
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.md};
  overflow: hidden;
`;

export const ImpactToggle = styled.button`
  width: 100%;
  border: none;
  border-bottom: 1px solid ${rawColors.stroke[200]};
  background: ${rawColors.structural.white};
  padding: ${spacing[3]} ${spacing[4]};
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${typographyMixin("body", 2)}
  color: ${rawColors.text.highEmphasis};
  cursor: pointer;
`;

export const ImpactContent = styled.div`
  padding: ${spacing[3]};
  background: ${rawColors.primary[50]};
`;

export const StoryTree = styled.div`
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.md};
  padding: ${spacing[3]};
  background: ${rawColors.structural.white};
`;

export const StoryRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  padding: ${spacing[1]} 0;
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.highEmphasis};
`;

export const StoryBadge = styled.span`
  min-width: 20px;
  height: 20px;
  border-radius: ${borderRadius.sm};
  background: ${rawColors.accent.purpleLight};
  color: ${rawColors.brand.primary};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${typographyMixin("caption", 3)}
`;

export const StoryChildren = styled.div`
  margin-left: ${spacing[4]};
  border-left: 1px solid ${rawColors.stroke[200]};
  padding-left: ${spacing[3]};
`;

export const ConfirmInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.md};
  background: ${rawColors.structural.white};
  color: ${rawColors.text.highEmphasis};
  padding: ${spacing[3]} ${spacing[4]};
  ${typographyMixin("body", 3)}

  &::placeholder {
    color: ${rawColors.text.mediumEmphasis};
  }
`;

export const ModalFooter = styled.div`
  border-top: 1px solid ${rawColors.stroke[200]};
  padding: ${spacing[4]} ${spacing[5]};
  display: flex;
  justify-content: flex-end;
  gap: ${spacing[2]};
`;

export const FooterButton = styled.button<{ $tone?: "danger" }>`
  min-width: 156px;
  border-radius: ${borderRadius.md};
  border: ${({ $tone }) =>
    $tone === "danger" ? "none" : `1px solid ${rawColors.stroke[200]}`};
  background: ${({ $tone }) =>
    $tone === "danger" ? rawColors.primary[900] : rawColors.structural.white};
  color: ${({ $tone }) =>
    $tone === "danger" ? rawColors.structural.white : rawColors.text.mediumEmphasis};
  padding: ${spacing[2]} ${spacing[4]};
  ${typographyMixin("body", 3)}
  font-weight: 500;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }
`;
